import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import { findCounter } from "./findCounter";

// Asigna usuarios a la plantilla de archivos
export const assignUsers = createAsyncThunk(
  "userProfileLocation/assignUsers",
  async (arg, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;
      const selectedUsers = state.formSubmittedSlice.selectedUsers;
      const template = state.templateDetail.template;
      let usersToSave = [...selectedUsers];
      const assignedUsers = state.formSubmittedSlice.assignedUsers;
      const idsToDelete: string[] = [];

      // Se comprueba si los usuarios ya asignados se encuentran dentro de los seleccionados.
      // Si los encuentra los elimina del listado para crear registros (usersToSave).
      // Si no los encuentra guarda el id en listado para eliminar registros (IdsToDelete).
      assignedUsers.forEach(async (element) => {
        if (usersToSave.find(({ user }) => user.id === element.user.id)) {
          usersToSave = usersToSave.filter(({ user }) => user.id !== element.user.id);
        } else {
          idsToDelete.push(element.id.toString());
        }
      });
      // Genera listado de ids de users para guardar registros
      const idsUsersToSave = usersToSave.map((element) => element.user.id);

      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      // Eliminar registros
      if (idsToDelete.length > 0) {
        const url = new URL(`${api.baseURL}formsubmitted/delete-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            toDelete: idsToDelete.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }

      // Crea registros
      if (idsUsersToSave.length > 0) {
        const url = new URL(`${api.baseURL}formsubmitted/create-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            form: template.id,
            toAddUserIds: idsUsersToSave.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }
      dispatch(findCounter({ form: template.id }));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
